var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('naver-maps',{attrs:{"height":_vm.height,"mapOptions":_vm.mapOptions}},[_c('naver-marker',{attrs:{"lat":_vm.lat,"lng":_vm.lng}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }